// extracted by mini-css-extract-plugin
export default {"cart-form":"CartForm_cart-form__iH0vg","action":"CartForm_action__SP5hL"};